import EventBus from '_lib/EventBus';
import {
  loadTrtcWebAPI,
  loadTrtcElectronAPI,
  loadVolcElectronAPI,
  loadRtcAPI,
  getAudioDevices,
  getAudioDevicesElectron,
} from '../utils'
import store from "@/store";
class rtcSdk {
  constructor() {
    this.RtcApi = null // 当前使用的rtc api
    this.RtcType = '' // 当前rtc的名称，[trtc, trtc_electron, volc, volc_electron]
    this.isRtcConnected = false; // 是否已经连接到语音
    this.isLocalTrackInited = false
  }
  // 获取所有麦克风扬声器设备
  async getAllDevices(use_electron_api) {
    let func = this.RtcApi && this.RtcApi.getAllDevices.bind(this.RtcApi) || (use_electron_api ? getAudioDevicesElectron : getAudioDevices)
    let [micDevices, voiceDevices] = await func()
    if (micDevices === -1 || voiceDevices === -1) { // 兼容火山引擎，没有createRTCVideo前获取设备列表返回-1
      return
    }
    if (this.RtcApi?.requireEnv === 'electron' || use_electron_api) {
      if (micDevices.length > 0) {
        micDevices.unshift({
          label: "默认设备",
          deviceId: 'default'
        })
      }
      if (voiceDevices.length > 0) {
        voiceDevices.unshift({
          label: "默认设备",
          deviceId: 'default'
        })
      }
    }

    // 过滤communications设备，防止被识别为通讯应用
    micDevices = micDevices.filter(v => v.deviceId !== 'communications')
    voiceDevices = voiceDevices.filter(v => v.deviceId !== 'communications')

    return [micDevices, voiceDevices]
  }

  // 设置rtc版本
  async setRtcApi(type) {
    if (!type || type === this.RtcType) {
      return
    }
    clientLog('[rtcSdk] setRtcApi', type)
    let lastRtcApi = this.RtcApi
    let originEnv = this.RtcApi?.requireEnv
    this.RtcApi = await loadRtcAPI(type)
    this.RtcType = type
    EventBus.$emit('Rtc_Type_Change', type)
    
    if (lastRtcApi?.destroyEngine)  {
      lastRtcApi.destroyEngine()
    }

    return {
      rtcRequireEnvChange: this.RtcApi.requireEnv !== originEnv
    }
  }

  async createClient(data) {
    await this.RtcApi.createClient(data)
  }

  async join(data) {
    await this.RtcApi.join(data);
    this.isRtcConnected = true
  }
  async leave() {
    await this.RtcApi.leave();
    this.isRtcConnected = false;
  }
  async publish(trackParams) {
    if(!this.isRtcConnected) return
    await this.RtcApi?.publish(trackParams);
  }
  async unpublish() {
    if(!this.isRtcConnected) return
    await this.RtcApi?.unpublish();
  }

  async createTrack(force, data, trackParams, {micDevices, micLevel, audio_press_mode}) {
    if (!this.RtcApi) return

    if (this.RtcApi.audioTrack && !force) {
      await this.RtcApi.setAudioProfile(data.audio_bitrate || 128)
      return
    }
    try {
      // 如果标记为已加入频道，先取消本地音轨的发布
      if (this.isRtcConnected) {
        await this.RtcApi.unpublish();
        await this.RtcApi.stopAudioCapture();
        await this.RtcApi.closeLocalTrack();
      }
    } catch(e) {
      console.log(e)
    }
    // 就算createTrack失败了（比如由于没有mic设备），也标记为inited
    this.isLocalTrackInited = true;
    await this.RtcApi.createTrack(trackParams);
    await this.RtcApi.startAudioCapture(trackParams);

    if (this.isRtcConnected && !data.isMuteBanned && !data.isHostModeBanned) {
      await this.RtcApi.publish(trackParams);
      if (micDevices.length == 0) {
        throw new Error('No Mic Devices found')
      }
      this.setLocalVolume(micLevel)
    }
    if (audio_press_mode) {
      await this.RtcApi.setMuted(true)
    }
  }

  async destroyTrack() {
    await this.RtcApi.closeLocalTrack();
    this.isLocalTrackInited = false;
  }

  async createTestTrack(cb, playback, trackParams, {curMicId, curVoiceId}) {
    if (this.RtcApi.createTestTrack) {
      await this.RtcApi.createTestTrack(cb, trackParams, playback)
    } else {
      (await loadTrtcWebAPI()).createTestTrack(cb, trackParams);
    }
    
    this.isTestTrackInited = true
    if (this.RtcApi.setTestMicDevice) {
      await this.RtcApi.setTestMicDevice(curMicId);
    } else {
      await this.setMicDevice(curMicId);
    }

    if (curVoiceId) {
      await this.setRemoteVoiceDevice(curVoiceId);
    }
  }

  async closeTestTrack(playback) {
    if (!this.RtcApi) return
    if (this.RtcApi.closeTestTrack) {
      await this.RtcApi.closeTestTrack(playback)
    } else {
      let sdk = await loadTrtcWebAPI()
      await sdk.closeTestTrack()
    }
    this.isTestTrackInited = false
  }

  async initLocalMicListener(micListerCallback) {
    // 初始化声音音量监听
    let sdk = await loadTrtcWebAPI()
    sdk.initListenTrack(micListerCallback)
  }

  async destroyLocalMicListener() {
    let sdk = await loadTrtcWebAPI()
    sdk.releaseListenTrack()
  }

  setMuted(bl) {
    this.RtcApi?.setMuted(bl)
  }

  async setLocalVolume(v) {
    if (!this.RtcApi) return
    await this.RtcApi.setLocalVolume(v)
  }

  setPlayoutVolume(v) {
    if (!this.RtcApi) return true

    if (!this.RtcApi?.setPlayoutVolume) return false
    this.RtcApi?.setPlayoutVolume(v)
    return true
  }

  setUserPlayoutVolume(id, userVolume, {isMuteEarphone}, {voiceLevel}) {
    if (!this.RtcApi) return true
    if (this.RtcApi.setPlayoutVolume) { // 如果有直接设置扬声器音量的方法，则不需要扬声器音量和用户音量的计算值
      this.RtcApi.changeUserVolume(id, userVolume)
    } else {
      let playoutLevel = isMuteEarphone ? 0 : voiceLevel
      this.RtcApi.changeUserVolume(id, playoutLevel * userVolume / 100)
    }
  }

  async setRemoteVoiceDevice(id) {
    await this.RtcApi?.setRemoteVoiceDevice(id);
  }

  async setMicDevice(id) {
    if (!this.RtcApi) return
    if (this.isLocalTrackInited || this.isTestTrackInited) {
      await this.RtcApi.setMicDevice(id);
    }
  }

  async changeSystemAudioLoopback(bl, path, bgm_volume) {
    if (!this.RtcApi) return
    this?.RtcApi?.changeSystemAudioLoopback && await this.RtcApi.changeSystemAudioLoopback(bl, path)
    bl && this.changeSystemAudioLoopbackVolume(bgm_volume)
  }

  changeSystemAudioLoopbackVolume(v) {
    if (!this.RtcApi) return
    this?.RtcApi?.setSystemAudioLoopbackVolume && this.RtcApi.setSystemAudioLoopbackVolume(v)
  }

  changeRtcPlugin({type, value, param}) {
    if (!this.RtcApi) return
    if (value) {
      this.RtcApi.setPluginParams && this.RtcApi.setPluginParams(type, param)
    } else {
      this.RtcApi.removePlugin && this.RtcApi.removePlugin(type)
    }
  }

  async setRtc3A(trackParams, clientData, setting_data) {
    if (!this.RtcApi) return

    if (this.RtcType.includes('trtc')) {
      // trtc 可以动态切换3a
      await this.RtcApi.createTrack(trackParams);
    } else {
      try {
        // volc需要重新创建track才能切换3a
        this.createTrack(force, clientData, trackParams, setting_data)
      } catch (e) {
        console.error(e)
      }
    }
  }

  setAIDenoiser(v) {
    return this.RtcApi && this.RtcApi.changeAIDenoiser && this.RtcApi.changeAIDenoiser(v)
  }

  getRemoteUsers() {
    return this.RtcApi?.getRemoteUsers() || {}
  }

  async getScreenCaptureSources() {
    let sdk = this.RtcType.includes('trtc') ? await loadTrtcElectronAPI() : await loadVolcElectronAPI()
    return sdk.getScreenCaptureSources()
  }

  addWebDeviceEvent(cb) {
    this._webDeviceEventCb = cb
    navigator?.mediaDevices.addEventListener('devicechange', cb);
  }
  removeWebDeviceEvent() {
    navigator?.mediaDevices.removeEventListener('devicechange', this._webDeviceEventCb);
  }
  addElectronDeviceEvent(cb) {
    if (!window.electronAPI?.onAudioDeviceChange) {
      return
    }
    window.electronAPI.onAudioDeviceChange(cb)
  }
  removeElectronDeviceEvent() {
    if (!window.electronAPI?.offAudioDeviceChange) {
      return
    }
    window.electronAPI.offAudioDeviceChange()
  }
  // 开始录音
  startRecord(filePath) {
    if(this.RtcType.includes('electron') && this.isRtcConnected) {
      return this.RtcApi.startRecord(filePath)
    } else {
      return false
    } 
  }

  // 停止录音
  stopRecord() {
    if(this.RtcType.includes('electron')) {
      return this.RtcApi.stopRecord()
    } else {
      return false
    }
  }


  changeHostModeBanned(v) {
    if(!this.RtcApi) return
    this.RtcApi.changeHostModeBanned(v)
  }

}

export default new rtcSdk();